import React, { useEffect } from 'react';
import { collection, getDocs, orderBy, query, limit } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { db } from '../utils/firebase';
import { setResolvedImageUrl } from '../utils/imageCache';

const ImagePrefetcher: React.FC = () => {
  useEffect(() => {
    let isCancelled = false;
    let storage: ReturnType<typeof getStorage> | null = null;
    try {
      storage = getStorage();
    } catch (_) {
      storage = null; // fail open; just skip prefetching
    }

    const resolveImageUrl = async (path: string): Promise<string> => {
      try {
        if (!path) return '';
        if (path.startsWith('http')) return path;
        if (!storage) return '';
        const imageRef = ref(storage, path);
        const url = await getDownloadURL(imageRef);
        return url;
      } catch (_) {
        return '';
      }
    };

    const run = async () => {
      try {
        const activitiesCollection = collection(db, 'activities');
        const q = query(activitiesCollection, orderBy('date', 'desc'), limit(20));
        const snap = await getDocs(q);
        const items = await Promise.all(
          snap.docs.map(async (d) => {
            const data = d.data();
            const raw = typeof data.imageUrl === 'string' ? data.imageUrl : '';
            const resolved = await resolveImageUrl(raw);
            return { raw, resolved };
          })
        );
        if (isCancelled) return;
        items.forEach(({ raw, resolved }) => {
          if (!resolved) return;
          setResolvedImageUrl(raw, resolved);
          const img = new Image();
          (img as any).decoding = 'async';
          img.src = resolved;
        });
      } catch (_) {
        // ignore background errors
      }
    };

    run();
    return () => {
      isCancelled = true;
    };
  }, []);

  return null;
};

export default ImagePrefetcher;


